export default {"src":"/_next/static/media/business-insider.530d3bf5.svg","height":16,"width":53,"blurWidth":0,"blurHeight":0};